import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StatusBadge from "./StatusBadge";
import { fosDisplayLabel, hasStatusChip, statusAccentColor } from "./partnersMobileUtils";
import css from "./partnersMobile.module.css";

// One FOS, carrying the same fields as the desktop FOS grid: FoSID + chip,
// name, contact (number and email) and CP. The chip follows the desktop
// FoSID column: "Disabled" when the login is disabled, otherwise the
// approval status chip.
export default function FosCard({ row, onOpen, onAction }) {
  const chip = { status: row.approvalStatus, disabled: row.isDisabled };
  const showChip = hasStatusChip(chip);
  const accent = statusAccentColor(showChip ? chip : {});
  const idLabel = fosDisplayLabel(row);

  return (
    <div className={css.card} style={{ borderLeftColor: accent }}>
      <div className={css.cardHeader}>
        <span className={css.cardId}>{idLabel}</span>
        {showChip && <StatusBadge status={row.approvalStatus} disabled={row.isDisabled} />}
        <span className={css.cardHeaderSpacer} />
        <button
          type="button"
          className={css.kebab}
          aria-label={`Actions for ${idLabel}`}
          onClick={(e) => {
            e.stopPropagation();
            onAction(row);
          }}
        >
          <MoreVertIcon sx={{ fontSize: 20 }} />
        </button>
      </div>

      <button type="button" className={css.cardBody} onClick={() => onOpen(row)}>
        <div className={css.cardTitle}>{row.name || "—"}</div>
        <div className={css.kv}>
          <span className={css.kvKey}>Contact</span>
          <span className={css.kvValue}>{row.contactNumber || "—"}</span>
        </div>
        <div className={css.kv}>
          <span className={css.kvKey}>Email</span>
          <span className={css.kvValue}>{row.email || "—"}</span>
        </div>
        <div className={css.kv}>
          <span className={css.kvKey}>CP</span>
          <span className={css.kvValue}>{row.cpName || "—"}</span>
        </div>
      </button>
    </div>
  );
}
